import React, { ReactNode, FC } from "react";
import Hovericon from "@/assets/videoparsing/selectaciveicon.png";
import "./UploadMaskBlock.less";

interface IUploadMaskBlockItemProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const OptionItem: FC<IUploadMaskBlockItemProps> = (props) => {
  const { children, className, style } = props;
  return (
    <div className={`${className} upload-mask-item-props`} style={style}>
      {children}
    </div>
  );
};

export interface IUploadMaskBlockProps {
  hoverable?: boolean;
  children?: ReactNode;
  className?: string;
  style: React.CSSProperties;
  content?: ReactNode;
  onClick?: (e) => void;
}

const UploadMaskBlock: FC<IUploadMaskBlockProps> & {
  Item: FC<IUploadMaskBlockItemProps>;
} = ({ onClick, hoverable = true, children, className, style, content }) => {
  console.log("hoverable", hoverable);

  return (
    <div
      className={`${className} upload-mask-block ${hoverable ? "hoverable" : ""}`}
      style={{ marginRight: 13, ...style }}
    >
      <div
        className="content"
        onClick={(e) => {
          onClick(e);
          e.stopPropagation();
          return false;
        }}
      >
        {content ? (
          content
        ) : (
          <>
            <img src={Hovericon} alt="" />
            <p>选择素材</p>
            <p className="tip">
              支持上传mov、mp4、mp3、jpg、png、gif、jpeg格式，
              单个文件大小不超过5GB
            </p>
          </>
        )}
      </div>
      <div className="children-wrapper">{children}</div>
    </div>
  );
};

UploadMaskBlock.Item = OptionItem;

export default UploadMaskBlock;
